import { gql } from '@apollo/client';

export const ORGANIZATION_SUBSCRIPTION = gql`
  query organizationSubscription {
    organizationSubscription {
      success
      errors
      subscriptionPlan
      cancelAtPeriodEnd
      currentPeriodEnd
      card {
        brand
        last4
        expMonth
        expYear
      }
    }
  }
`;

export const CREATE_CHECKOUT_SESSION = gql`
  mutation createCheckoutSession($planId: String!, $successUrl: String!, $cancelUrl: String!) {
    createCheckoutSession(planId: $planId, successUrl: $successUrl, cancelUrl: $cancelUrl) {
      success
      errors
      url
    }
  }
`;

export const CREATE_STAFF_SEAT_CHECKOUT_SESSION = gql`
  mutation createStaffSeatCheckoutSession($quantity: Int!, $successUrl: String!, $cancelUrl: String!) {
    createStaffSeatCheckoutSession(quantity: $quantity, successUrl: $successUrl, cancelUrl: $cancelUrl) {
      success
      errors
      url
    }
  }
`;

export const CREATE_BILLING_PORTAL_SESSION = gql`
  mutation createBillingPortalSession($returnUrl: String!) {
    createBillingPortalSession(returnUrl: $returnUrl) {
      success
      errors
      url
    }
  }
`;

export const CANCEL_ORGANIZATION_SUBSCRIPTION = gql`
  mutation cancelOrganizationSubscription {
    cancelOrganizationSubscription {
      success
      errors
      subscriptionPlan
      cancelAtPeriodEnd
      currentPeriodEnd
      card {
        brand
        last4
        expMonth
        expYear
      }
    }
  }
`;
